import {
  CategoryListView,
  CategoryNewView,
  CategoryEditView,
} from '@/views/authenticated/categories';

export default [
  {
    path: '/frameworks/:framework/categories',
    name: 'app_category_list',
    meta: { title: 'Framework Categories', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: CategoryListView,
  },
  {
    path: '/frameworks/:framework/categories/new',
    name: 'app_category_new',
    meta: { title: 'Add a Category', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: CategoryNewView,
  },
  {
    path: '/frameworks/:framework/categories/:category/edit',
    name: 'app_category_edit',
    meta: { title: 'Edit a Category', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: CategoryEditView,
  },
];
